<template>
  <ul class="featured-benefits">
    <li
      v-for="benefit, index in benefits"
      :key="index"
      class="featured-benefit"
    >
      <div class="featured-benefit__image-container">
        <CdrImg
          class="featured-benefit__image"
          :alt="benefit?.image?.alt"
          :src="benefit?.image?.src"
        />
      </div>
      <CdrButton
        class="featured-benefit__link"
        modifier="link"
        :data-analytics-id="`${benefit?.heading}_modal open`"
        @click="() => handleClick(benefit)"
      >
        {{ benefit?.heading }}
      </CdrButton>
    </li>
  </ul>
</template>

<script setup>
import { CdrButton, CdrImg } from '@rei/cedar';

defineProps({
  benefits: {
    type: Array,
    required: true,
  },
});

const emit = defineEmits(['click']);

const handleClick = (benefit) => {
  const {
    image, heading, body, links,
  } = benefit;
  const payload = {
    image, heading, body, links,
  };
  emit('click', payload);
};
</script>

<style lang="scss">
.featured-benefits {
  list-style-type: none;
  padding: 0;
  margin: 0 auto $cdr-space-one-x;
  display: grid;
  grid-column-gap: $cdr-space-one-x;
  grid-row-gap: $cdr-space-one-and-a-half-x;
  grid-template-columns: 1fr 1fr;
  @include cdr-md-mq-up {
    grid-auto-flow: column;
    grid-auto-columns: 1fr;
    grid-column-gap: $cdr-space-one-and-a-half-x;
    margin-bottom: $cdr-space-two-x;
  }
}

.featured-benefit {
  position: relative;
}

.featured-benefit__image-container {
  margin-bottom: $cdr-space-one-x;
  @include cdr-md-mq-up {
    border-radius: $cdr-radius-softer;
  }
}
.featured-benefit__image {
  max-width: 110px;
  display: block;
  margin: 0 auto;
  @include cdr-md-mq-up {
    max-width: 160px;
  }
}
.featured-benefit__link.featured-benefit__link {
  font-size: $cdr-text-body-400-size;
  text-align: center;
  margin: 0 auto;
  padding: 0;
  display: block;
  &::after {
    display: block;
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;
  }
}
</style>
